import {Injectable} from '@angular/core';

@Injectable({
  providedIn:'root'
})
export class DecodeTokenService{

  decodeToken(token: string): any {
    try {
      const payload = token.split('.')[1];
      const decodedPayload = atob(payload);
      return JSON.parse(decodedPayload);
    } catch (error) {
      console.error('Invalid token', error);
      return null;
    }
  }

}
